<app-site-banner></app-site-banner>
<main id="main-content">
  <router-outlet></router-outlet>
</main>
<app-site-identifier></app-site-identifier>
